




import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../../styles/Mahal.css";
import "../../styles/styles1.css";
import { resolveIdentity } from "../../utils/identity";
import logo from "../../images/Logo1.png";
import userAvatar from "../../images/user-avatar.png";
import { useTranslation } from "react-i18next";
import { APP_URLS } from "../../config/routes";
import alifLogo from "../../images/mahalai5.png";
import ChatDrawer from "../MahalAI/ChatDrawer";
import "../MahalAI/ChatDrawer.css"

const Header = ({ onProfileClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchRef = useRef(null);
  const identity = resolveIdentity();
  const { t, i18n } = useTranslation();
  const [locationText, setLocationText] = useState(t("fetching_location"));
  const [showUserMenu, setShowUserMenu] = useState(false);
  const restaurantId = localStorage.getItem("linked_id");
  const username = localStorage.getItem("username")?.split("@")[0] || "User";
  const [query, setQuery] = useState("");
  const [searchCategory, setSearchCategory] = useState("All");
  const [allProducts, setAllProducts] = useState([]);
  const [recentSearches, setRecentSearches] = useState([]);
  const [trendingSearches, setTrendingSearches] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [notificationCount, setNotificationCount] = useState(0);
  const [cartCount, setCartCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);
  const [showMahalAI, setShowMahalAI] = useState(false);


  /* LOAD COUNTS */
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    fetch("https://api.mahal.qa/api/notifications/count", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(d => setNotificationCount(d.count || 0))
      .catch(() => setNotificationCount(0));
    fetch("https://api.mahal.qa/api/cart/count", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(d => setCartCount(d.count || 0))
      .catch(() => setCartCount(0));
    /* WISHLIST COUNT */
    fetch("https://api.mahal.qa/api/wishlist/count", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(d => setWishlistCount(d.count || 0))
      .catch(() => setWishlistCount(0));
  }, []);

  /* LOAD PRODUCTS */
  useEffect(() => {
    const token = localStorage.getItem("token");

    fetch("https://api.mahal.qa/api/gridlist", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(data => setAllProducts(data.products || []))
      .catch(() => setAllProducts([]));
  }, []);

  /* RECENT + TRENDING */
  /* RECENT + TRENDING */
  useEffect(() => {
    if (!restaurantId) return;

    fetch(`https://api.mahal.qa/api/search/recent?restaurant_id=${restaurantId}`)
      .then(res => res.json())
      .then(data => setRecentSearches(Array.isArray(data) ? data : []))
      .catch(() => setRecentSearches([]));

    fetch(`https://api.mahal.qa/api/search/trending?restaurant_id=${restaurantId}`)
      .then(res => res.json())
      .then(data => setTrendingSearches(Array.isArray(data) ? data : []))
      .catch(() => setTrendingSearches([]));
  }, [restaurantId]);
  // ✅ PUT IT HERE
  // useEffect(() => {
  //   const params = new URLSearchParams(location.search);
  //   const searchParam = params.get("search");

  //   if (searchParam) {
  //     setQuery(searchParam);
  //   }
  // }, [location.search]);


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchParam = params.get("search");

    if (searchParam) {
      setQuery(searchParam);
    } else {
      setQuery("");
    }
  }, [location.search]);

  /* AUTOCOMPLETE */
  useEffect(() => {
    if (!query) {
      setSuggestions([]);
      // setShowSuggestions(true);   // 👈 IMPORTANT
      return;
    }
    const filtered = Array.from(
      new Map(
        allProducts
          .filter(p =>
            (p.name || p.product_name_english || "")
              .toLowerCase()
              .includes(query.toLowerCase())
          )
          .map(p => {
            const name = p.name || p.product_name_english;
            return [name.toLowerCase(), { ...p, displayName: name }];
          })
      ).values()
    ).slice(0, 8);
    setSuggestions(filtered);
    setShowSuggestions(true);
    setActiveIndex(-1);
  }, [query, allProducts]);

  /* CLICK OUTSIDE */
  useEffect(() => {
    const handleClick = e => {
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        setShowSuggestions(false);
        setShowOverlay(false);
      }
    };

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  // const handleSearch = text => {
  //   const q = (text || query).trim();
  //   if (!q) return;

  //   fetch("https://api.mahal.qa/api/search/log", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({ search_text: q }),
  //   });

  //   setQuery(q);          // ← important
  //   setShowSuggestions(false);
  //   setShowOverlay(false);

  //   navigate(
  //     `/CategorieList?search=${encodeURIComponent(
  //       q
  //     )}&category=${searchCategory}`
  //   );
  // };

  const handleSearch = (text) => {
    const q = typeof text === "string" ? text.trim() : query.trim();

    if (!q) return;

    fetch("https://api.mahal.qa/api/search/log", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        search_text: q,
        restaurant_id: restaurantId,
      }),
    });

    setQuery(q);
    setShowSuggestions(false);
    setShowOverlay(false);

    window.location.assign(
      `${APP_URLS.WEBSITE}/CategorieList?search=${encodeURIComponent(q)}&category=${searchCategory}`
    );
  };

  /* AUTOCOMPLETE */
  useEffect(() => {
    const q = query.trim();

    if (!q) {
      setSuggestions([]);
      setActiveIndex(-1);
      return;
    }

    const timer = setTimeout(() => {
      fetch(`https://api.mahal.qa/api/products/search?q=${encodeURIComponent(q)}`)
        .then(res => res.json())
        .then(data => {
          const list = Array.isArray(data) ? data : [];

          const unique = Array.from(
            new Map(
              list.map(p => {
                const name = p.name || p.product_name_english;
                return [name?.toLowerCase(), { ...p, displayName: name }];
              })
            ).values()
          ).slice(0, 8);

          setSuggestions(unique);
          setShowSuggestions(true);
          setActiveIndex(-1);
        })
        .catch(() => setSuggestions([]));
    }, 300);

    return () => clearTimeout(timer);
  }, [query]);

  // const handleLogout = () => {
  //   localStorage.removeItem("token");
  //   localStorage.removeItem("role");
  //   localStorage.removeItem("linked_id");
  //   localStorage.removeItem("username");

  //   window.location.href = `${APP_URLS.WEBSITE}/restaurantlogin`;
  // };


  const handleLogout = async () => {
    const token = localStorage.getItem("token");

    try {
      if (token) {
        await fetch("https://api.mahal.qa/api/auth/logout", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
    } catch (err) {
      console.error("Logout failed:", err);
    }

    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("linked_id");
    localStorage.removeItem("username");

    window.location.href = `${APP_URLS.WEBSITE}/restaurantlogin`;
  };


  useEffect(() => {
    const verifySession = async () => {
      const token = localStorage.getItem("token");
      const role = localStorage.getItem("role");

      if (!token || role?.toLowerCase() !== "restaurant") return;

      try {
        const res = await fetch("https://api.mahal.qa/api/auth/verify", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) {
          localStorage.clear();
          sessionStorage.clear();
          window.location.replace(`${APP_URLS.WEBSITE}/restaurantlogin`);
        }
      } catch {
        localStorage.clear();
        sessionStorage.clear();
        window.location.replace(`${APP_URLS.WEBSITE}/restaurantlogin`);
      }
    };

    verifySession();
    const interval = setInterval(verifySession, 5000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const loadCount = () => {
      fetch(
        "https://api.mahal.qa/api/v1/orders/restaurant/notifications/count",
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
        .then(res => res.json())
        .then(data => setNotificationCount(data.count || 0))
        .catch(() => setNotificationCount(0));
    };

    loadCount();
    window.addEventListener("refreshNotifications", loadCount);

    return () =>
      window.removeEventListener("refreshNotifications", loadCount);
  }, []);
  useEffect(() => {
    const restaurantId = localStorage.getItem("linked_id");

    const loadDefaultLocation = async () => {
      try {
        const res = await fetch(
          `https://api.mahal.qa/api/location/address/default/${restaurantId}`
        );
        const data = await res.json();

        if (data?.area) {
          setLocationText(`${data.area}, ${data.city}`);
        }
      } catch { }
    };

    const detectLocation = () => {
      navigator.geolocation.getCurrentPosition(
        async pos => {
          const lat = pos.coords.latitude;
          const lon = pos.coords.longitude;

          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
          );
          const geo = await res.json();

          const area =
            geo.address.suburb ||
            geo.address.neighbourhood ||
            geo.address.village ||
            geo.address.town ||
            "";

          const city =
            geo.address.city ||
            geo.address.state_district ||
            "";

          const state = geo.address.state || "";

          setLocationText(`${area}, ${city}`);

          await fetch("https://api.mahal.qa/api/location/address", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              restaurant_id: restaurantId,
              latitude: lat,
              longitude: lon,
              area,
              city,
              state,
              address_text: geo.display_name,
              is_default: true
            }),
          });
        },
        async () => {
          const res = await fetch("https://ipapi.co/json/");
          const data = await res.json();
          setLocationText(`${data.city}`);
        }
      );
    };

    loadDefaultLocation();
    detectLocation();
  }, []);

  const removeRecentSearch = async (e, text) => {
    e.stopPropagation();

    try {
      await fetch("https://api.mahal.qa/api/search/recent/delete", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          search_text: text,
          restaurant_id: restaurantId,
        }),
      });

      setRecentSearches(prev =>
        prev.filter(item => item.search_text !== text)
      );
    } catch (err) {
      console.log("Failed to delete recent search", err);
    }
  };

  return (
    <>
      {showOverlay && <div className="search_overlay" />}

      <div className="mahal_dashboard dashboard_header">
        <div className="mahal_header header_top">

          {/* LEFT */}
          <div className="header_left">
            <a href={`${APP_URLS.WEBSITE}/restaurantoffers`} className="mahal_logo">
              <img src={logo} alt="logo" />
            </a>

            {/* LOCATION */}
            <div className="location_box">
              <i className="fas fa-map-marker-alt"></i>
              <span className="location_text">{locationText}</span>
              <i className="fas fa-chevron-down"></i>
            </div>
          </div>
          {/* SEARCH */}
          <div className="search_wrapper" id="search" ref={searchRef}>
            {/* <select
                className="search_bar"
                style={{ maxWidth: "120px" }}
                value={searchCategory}
                onChange={(e) => setSearchCategory(e.target.value)}
              >
                <option value="All">All</option>
                <option value="Vegetables">Vegetables</option>
                <option value="Fruits">Fruits</option>
                <option value="Groceries">Groceries</option>
              </select> */}

            <input
              className="search_bar"
              placeholder={t("search_ingredients_products")}
              value={query}
              onFocus={() => {
                setShowOverlay(true);

                if (query) {
                  const filtered = Array.from(
                    new Map(
                      allProducts
                        .filter(p =>
                          (p.name || p.product_name_english || "")
                            .toLowerCase()
                            .includes(query.toLowerCase())
                        )
                        .map(p => {
                          const name = p.name || p.product_name_english;
                          return [name.toLowerCase(), { ...p, displayName: name }];
                        })
                    ).values()
                  ).slice(0, 8);

                  setSuggestions(filtered);
                }

                setShowSuggestions(true);
              }}


              // onChange={(e) => setQuery(e.target.value)}


              onChange={(e) => {
                const value = e.target.value;
                setQuery(value);

                if (value.trim() === "") {
                  setSuggestions([]);
                  setShowSuggestions(false);
                  setShowOverlay(false);

                  window.location.href =
                    `${APP_URLS.WEBSITE}/CategorieList?category=${searchCategory}`;
                }
              }}

              onKeyDown={(e) => {
                if (e.key === "ArrowDown")
                  setActiveIndex(i =>
                    Math.min(i + 1, suggestions.length - 1)
                  );

                if (e.key === "ArrowUp")
                  setActiveIndex(i => Math.max(i - 1, 0));

                if (e.key === "Enter") {
                  const selected =
                    activeIndex >= 0
                      ? suggestions[activeIndex].displayName ||
                      suggestions[activeIndex].name ||
                      suggestions[activeIndex].product_name_english
                      : query;

                  setShowSuggestions(false);
                  setShowOverlay(false);
                  handleSearch(selected);
                }

              }}
            />

            {/* <button className="search_btn" onClick={handleSearch}> */}

            <button className="search_btn" onClick={() => handleSearch()}>
              <i className="fas fa-search"></i>
            </button>

            {showSuggestions && (
              <div className="search_dropdown">

                {!query && recentSearches.length > 0 && (
                  <>
                    <div className="search_item" style={{ fontWeight: "bold" }}>
                      {t("recent")}
                    </div>
                    {recentSearches.map((r, i) => (
                      <div
                        key={`recent-${i}`}
                        className="search_item recent_item"
                        onClick={() => handleSearch(r.search_text)}
                      >
                        <span>🕒 {r.search_text}</span>

                        <button
                          type="button"
                          className="recent_remove_btn"
                          onClick={(e) => removeRecentSearch(e, r.search_text)}
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </>
                )}

                {!query && trendingSearches.length > 0 && (
                  <>
                    {/* <div className="search_item" style={{ fontWeight: "bold" }}>
          Trending
        </div> */}
                    {trendingSearches.map((t, i) => (
                      <div
                        key={`trend-${i}`}
                        className="search_item"
                        onClick={() => handleSearch(t.search_text)}
                      >
                        🔥 {t.search_text}
                      </div>
                    ))}
                  </>
                )}

                {suggestions.map((p, i) => {
                  const name = p.displayName || p.name || p.product_name_english;

                  return (
                    <div
                      key={p.product_id || p.id || i}
                      className={`search_item ${i === activeIndex ? "active" : ""}`}
                      onClick={() => handleSearch(name)}
                    >
                      {name}
                    </div>
                  );
                })}



              </div>
            )}

          </div>

          {/* LOCATION
            <div className="location_box">
              <i className="fas fa-map-marker-alt"></i>
              <span className="location_text">{locationText}</span>
              <i className="fas fa-chevron-down"></i>
            </div>
          </div> */}

          {/* RIGHT */}
          <div className="header_right">
            <button
              className="mahal_ai_header_btn"
              onClick={() => setShowMahalAI(true)}
            >
              <img
                src={alifLogo}
                alt="Mahal AI"
                className="mahal_ai_icon"
              />

              <span className="mahal_ai_text">
                Mahal AI
              </span>
            </button>
            <div
              className="user_box"
              onClick={() => setShowUserMenu(!showUserMenu)}
            >
              <img src={userAvatar} alt="user" className="user_avatar" />
              <span className="user_name">{username}</span>

              {showUserMenu && (
                <div className="user_dropdown">
                  <a
                    href={`${APP_URLS.CUSTOMER}/profile/${localStorage.getItem("role")}/${localStorage.getItem("linked_id")}`}
                  >
                    {t("my_profile")}
                  </a>
                </div>
              )}
            </div>

            <a
              href={`${APP_URLS.CUSTOMER}/restaurantdashboard/notifications`}
              className="icon_box"
            >
              <i className="fas fa-bell"></i>
              {notificationCount > 0 && (
                <span className="badge">{notificationCount}</span>
              )}
            </a>

            <a
              href={`${APP_URLS.CUSTOMER}/cartview`}
              className="icon_box"
            >
              <i className="fas fa-shopping-cart"></i>
              {cartCount > 0 && <span className="badge">{cartCount}</span>}
            </a>

            <a
              href={`${APP_URLS.CUSTOMER}/wishlist`}
              className="icon_box"
            >
              <i className="fa fa-heart"></i>
              {wishlistCount > 0 && <span className="badge">{wishlistCount}</span>}
            </a>

            <div className="icon_box logout_icon" onClick={handleLogout}>
              <i className="fas fa-sign-out-alt"></i>
            </div>
          </div>

        </div>
      </div>
      {showMahalAI && (
        <ChatDrawer
          mode="shopping"
          onClose={() => setShowMahalAI(false)}
        />
      )}
    </>
  );
};

export default Header;